import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';



@Injectable({
  providedIn: 'root'
})
export class LoginDataService
 {

  constructor(private http:HttpClient) { }

  getNewUser() {
    const oldRecords = localStorage.getItem('loginlist');
    if(oldRecords !== null) 
    {
      const loginlist = JSON.parse(oldRecords); // string to json obj
      return loginlist.length + 1;
    }
    else {
      return 1;
    }
  }

}